<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-flatten`]" width="1em" height="1em" v-bind="$attrs"><path d="M3.09424 11C3.92244 11.0003 4.59424 11.6717 4.59424 12.5C4.59411 13.3282 3.92236 13.9997 3.09424 14C2.26589 14 1.59437 13.3283 1.59424 12.5C1.59424 11.6716 2.26581 11 3.09424 11ZM13.7417 11.835C14.1088 11.8352 14.4067 12.1329 14.4067 12.5C14.4066 12.867 14.1087 13.1648 13.7417 13.165H7.33838C6.97119 13.165 6.67347 12.8672 6.67334 12.5C6.67334 12.1327 6.97111 11.835 7.33838 11.835H13.7417ZM3.09424 6.5C3.92244 6.50026 4.59424 7.17174 4.59424 8C4.59411 8.82815 3.92236 9.49974 3.09424 9.5C2.26589 9.5 1.59437 8.82831 1.59424 8C1.59424 7.17157 2.26581 6.5 3.09424 6.5ZM13.7417 7.33496C14.1088 7.33519 14.4067 7.63287 14.4067 8C14.4066 8.36702 14.1087 8.66481 13.7417 8.66504H7.33838C6.97119 8.66504 6.67347 8.36716 6.67334 8C6.67334 7.63273 6.97111 7.33496 7.33838 7.33496H13.7417ZM3.09424 2C3.92244 2.00026 4.59424 2.67174 4.59424 3.5C4.59411 4.32815 3.92236 4.99974 3.09424 5C2.26589 5 1.59437 4.32831 1.59424 3.5C1.59424 2.67157 2.26581 2 3.09424 2ZM13.7417 2.83496C14.1088 2.83518 14.4067 3.13287 14.4067 3.5C14.4066 3.86702 14.1087 4.16482 13.7417 4.16504H7.33838C6.97119 4.16504 6.67347 3.86716 6.67334 3.5C6.67334 3.13273 6.97111 2.83496 7.33838 2.83496H13.7417Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineFlatten',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
